import { Flex, Skeleton } from '@chakra-ui/react'
import React from 'react'
import TranscriptionLog from '~/pages/CallAnalytics/Transcription/TranscriptionLog'
import {
  CallDetailsRow,
  CallDetailsRowItem,
} from '~/pages/Calls/CallDetails/CallDetailsRow'
import { CallTranscript } from '~/types'

interface CallDetailsTranscriptTabProps {
  transcript?: CallTranscript
  isLoadingTranscripts: boolean
  playerPosition: number
  isAudioPlaying: boolean
  onPlay: (time?: number) => void
  onPause: () => void
}

export const CallDetailsTranscriptTab = ({
  transcript,
  playerPosition,
  isAudioPlaying,
  isLoadingTranscripts,
  onPlay,
  onPause,
}: CallDetailsTranscriptTabProps) => {
  return (
    <Flex flexDirection="column" gap="1.25rem" width="100%">
      {isLoadingTranscripts || !transcript ? (
        <>
          <Skeleton h="14rem" />
          <Flex w="full" h="8rem" gap="1.25rem">
            <Skeleton flexGrow="1" />
            <Skeleton flexGrow="1" />
          </Flex>
          <Flex w="full" h="8rem" gap="1.25rem">
            <Skeleton flexGrow="1" />
            <Skeleton flexGrow="1" />
          </Flex>
        </>
      ) : transcript && transcript.Transcript.length > 0 ? (
        <TranscriptionLog
          transcriptionData={transcript}
          isPlaying={isAudioPlaying}
          playerPosition={playerPosition}
          onPlay={onPlay}
          onPause={onPause}
        />
      ) : (
        <CallDetailsRow>
          <CallDetailsRowItem>Transcript is not available</CallDetailsRowItem>
        </CallDetailsRow>
      )}
    </Flex>
  )
}
